// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"10f3b9b0","171":"9becb90f","488":"5bd583e2"}[chunkId] + ".chunk.js";
};